import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useLang } from "@/context/LangContext";

export default function Navbar() {
    const [open, setOpen] = React.useState(false);
    const { lang, setLang, t } = useLang();

    const links = [
        { to: "/", label: t("nav_home"), key: "home" },
        { to: "/programs", label: t("nav_programs"), key: "programs" },
        { to: "/trainings", label: t("nav_trainings"), key: "trainings" },
        { to: "/reviews", label: t("nav_reviews"), key: "reviews" },
        { to: "/contact", label: t("nav_contact"), key: "contact" },
    ];

    return (
        <header data-testid="site-navbar"
                className="fixed top-0 left-0 right-0 z-50 bg-black/70 backdrop-blur-2xl border-b border-white/10">
            <div className="px-6 md:px-12 lg:px-20 py-4 flex items-center justify-between">
                <Link to="/" data-testid="logo-link" className="flex items-center gap-2">
                    <span className="w-2.5 h-2.5 bg-volt inline-block" />
                    <span className="font-heading text-2xl tracking-wider">Elite Player Academy</span>
                </Link>

                <nav className="hidden md:flex items-center gap-7">
                    {links.map((l) => (
                        <NavLink key={l.to} to={l.to} end={l.to === "/"}
                                 data-testid={`nav-${l.key}`}
                                 className={({ isActive }) =>
                                     `font-body text-sm uppercase tracking-[0.12em] transition-colors ${
                                         isActive ? "text-volt" : "text-white/80 hover:text-volt"}`}>
                            {l.label}
                        </NavLink>
                    ))}
                    <Link to="/trainings" data-testid="nav-cta-book"
                          className="btn-volt px-5 py-2.5 text-sm">
                        {t("nav_book")}
                    </Link>
                </nav>

                <button data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)}
                        className="md:hidden text-white" aria-label="Toggle menu">
                    {open ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            {open && (
                <div data-testid="mobile-menu"
                     className="md:hidden border-t border-white/10 px-6 py-6 flex flex-col gap-4 bg-black/95">
                    {links.map((l) => (
                        <NavLink key={l.to} to={l.to} end={l.to === "/"} onClick={() => setOpen(false)}
                                 data-testid={`mobile-nav-${l.key}`}
                                 className={({ isActive }) =>
                                     `font-body text-base uppercase tracking-[0.12em] ${
                                         isActive ? "text-volt" : "text-white"}`}>
                            {l.label}
                        </NavLink>
                    ))}
                    <div className="pt-2"></div>
                    <Link to="/trainings" onClick={() => setOpen(false)}
                          data-testid="mobile-nav-cta-book" className="btn-volt px-5 py-3 text-center mt-2">
                        {t("nav_book")}
                    </Link>
                </div>
            )}
        </header>
    );
}


function LangToggle({ lang, setLang }) {
    const isDE = lang === "de";
    return (
        <button
            data-testid="lang-toggle"
            onClick={() => setLang(isDE ? "en" : "de")}
            aria-label="Toggle language"
            className="inline-flex items-center border border-white/20 rounded-none px-1 py-0.5 text-[10px] font-heading tracking-widest gap-1 hover:border-volt transition-colors"
        >
            <span className={`px-1.5 py-0.5 ${!isDE ? "bg-volt text-black" : "text-white/60"}`}>EN</span>
            <span className={`px-1.5 py-0.5 ${isDE ? "bg-volt text-black" : "text-white/60"}`}>DE</span>
        </button>
    );
}
